class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      if (this.tagName !== 'PREDICTIVE-SEARCH') {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      }
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.normalizeSearchLocation();
    }
  }

  normalizeGovernedQuery(query) {
    return window.CardLegendsSearch.normalizeQuery(query);
  }

  normalizeSearchLocation() {
    if (!window.location.pathname.includes('/search')) return;
    const url = new URL(window.location.href);
    const query = url.searchParams.get('q');
    if (!query) return;
    const normalized = this.normalizeGovernedQuery(query);
    if (normalized === query) return;
    url.searchParams.set('q', normalized);
    window.location.replace(url.toString());
  }

  onFormSubmit() {
    this.input.value = this.normalizeGovernedQuery(this.input.value);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
